/**
 * Useful for merging user-supplied and library handlers while allowing users to prevent library handlers from firing.
 * The user-supplied handler should go first.
 */
export function composeEventHandlers<EventType extends React.SyntheticEvent | Event>(
  ...fns: (((event: EventType) => void) | undefined)[]
) {
  return function func(event: EventType) {
    fns.some(fn => {
      fn?.(event)
      return event?.defaultPrevented
    })
  }
}
